﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconMailFilled } from "@tabler/icons-react";

export const TiposEmailIcon = IconMailFilled;
export const TiposEmailHelpText = '* Aquí puede ver los diferentes tipos de emails.';

export class catTiposEmail extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposEmail";
        this.def.columns.c_category_id.defaultValue = "TiposEmail";
        this.Title = "Tipos de Email";
        this.HelpText = TiposEmailHelpText;
        this.Icon = TiposEmailIcon;
    }
}